var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 97,
    viewBox: "0 0 104 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "translateY(-20px)",
      marginTop: "-20px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_820_21787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.22 77.66C44.42 77.66 43.76 77 43.76 76.2V69.34C43.76 65.26 40.44 61.92 36.34 61.92C32.24 61.92 28.92 65.26 28.92 69.34V76.2C28.92 77 28.26 77.66 27.46 77.66C26.66 77.66 26 77 26 76.2V69.34C26 63.64 30.64 59 36.34 59C42.04 59 46.68 63.64 46.68 69.34V76.2C46.68 77.02 46.02 77.66 45.22 77.66Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0684 74.7402H39.9484C37.5884 74.7402 35.6484 76.6602 35.6484 79.0402V92.7002C35.6484 95.0602 37.5684 97.0002 39.9484 97.0002H62.0684C64.4284 97.0002 66.3684 95.0802 66.3684 92.7002V79.0402C66.3684 76.6602 64.4284 74.7402 62.0684 74.7402ZM52.4684 87.0602C52.4684 87.8602 51.8084 88.5202 51.0084 88.5202C50.2084 88.5202 49.5484 87.8602 49.5484 87.0602V84.6802C49.5484 83.8802 50.2084 83.2202 51.0084 83.2202C51.8084 83.2202 52.4684 83.8802 52.4684 84.6802V87.0602Z",
    fill: "url(#paint0_linear_820_21787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_820_21787",
    x: 23,
    y: 58,
    width: 26.6797,
    height: 24.6599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_820_21787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_820_21787",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_820_21787",
    x1: 35.6564,
    y1: 85.8722,
    x2: 66.3604,
    y2: 85.8722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86EC27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFF37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.2fa3da32.svg";
export { ForwardRef as ReactComponent };